<template>
  <div ref="treeDiv" class="tree-container">
    <el-tree class="tree" ref="tree" v-bind="$attrs" :indent="0" v-on="$listeners">
      <template slot-scope="{ node }">
        <span :title="node.label">{{ node.label }}</span>
      </template>
    </el-tree>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    returnRef() {
      return this.$refs.tree;
    },
  },
};
</script>
<style>
.tree .el-tree-node {
  position: relative;
  padding-left: 16px;
}

.tree .el-tree-node__children {
  overflow: inherit;
  padding-left: 16px;
}

.tree .el-tree-node :last-child:before {
  height: 13px;
}

.tree .el-tree > .el-tree-node:before {
  border-left: none;
}
.span-ellipsis {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tree-container .el-tree > .el-tree-node:after {
  border-top: none;
}

.tree .el-tree-node:before {
  content: "";
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
}

.tree .el-tree-node:after {
  content: "";
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
}

.tree .el-tree-node:before {
  border-left: 1px solid #ccc;
  bottom: 0px;
  height: 100%;
  top: 0px;
  width: 1px;
}

.tree .el-tree-node:after {
  border-top: 1px solid #ccc;
  height: 20px;
  top: 12px;
  width: 27px;
}

.tree-container {
  overflow: auto;
  padding-top: 10px;
  flex: 1;
}

.tree .el-tree-node__expand-icon.expanded {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}

.tree .el-icon-caret-right:before {
  content: "\e78a";
  font-size: 16px;
}

.tree .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
  content: "\e784";
  font-size: 16px;
}

.tree .el-tree-node__expand-icon.is-leaf.el-icon-caret-right:before {
  content: "\e78a";
  font-size: 16px;
  color: #c0c4cc;
}
</style>